module.exports = __webpack_public_path__ + "img/order-nodata.2cbf6878.png";